var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_700",
    "data-name": "Group 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.6,
    height: 11.6,
    viewBox: "0 0 11.6 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 11.6,
    height: 11.6,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M2.751.007,8.762,0A3.125,3.125,0,0,1,11.6,2.792V8.808A3.133,3.133,0,0,1,8.809,11.6H2.792A3.133,3.133,0,0,1,0,8.808V2.814A3.122,3.122,0,0,1,2.751.007M2.7,3.683a.381.381,0,0,0-.255.653L4.059,5.791c.006.033-.069.094-.095.118-.493.465-1.024.894-1.52,1.355a.382.382,0,1,0,.541.541c.657-.5,1.257-1.217,1.919-1.73.276-.334.022-.524-.215-.747C4.1,4.878,3.568,4.24,2.985,3.795A.435.435,0,0,0,2.7,3.683M5.771,7.159a.383.383,0,0,0,.021.764c.988-.068,2.119.1,3.09,0a.385.385,0,0,0,.022-.77Z",
    transform: "translate(0 0.001)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeReview);
export default __webpack_public_path__ + "static/media/CodeReview.e2b0e32fdeabd67e66d75e9e6b632579.svg";
export { ForwardRef as ReactComponent };